module.exports = __webpack_public_path__ + "img/ic_empty.8ee70e0c.png";